routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider','$mdDateLocaleProvider']

export default function routes ($stateProvider, $urlRouterProvider, $locationProvider,$mdDateLocaleProvider) {

      $mdDateLocaleProvider.formatDate = function(date) {
      var m = moment(date);
      return m.isValid() ? m.format('DD/MM/YYYY') : '';
    };

    $mdDateLocaleProvider.parseDate = function(dateString) {
        var m = moment(dateString, 'DD/MM/YYYY', true);
        return m.isValid() ? m.toDate() : new Date(NaN);
    };

  $locationProvider.html5Mode(true)
  $stateProvider
  .state('workPlanParametrization', {
    abstract: false,
    url: '/app/workPlanParametrization',
    redirectTo: 'fullscreen.workPlanParametrization',
    views: {
      '': {
        template: require('../../../layout/layout.html')
      },
      'content': {
        template: require('../../../layout/content.html')
      },
      'aside': {
        template: require('../../../layout/aside.html'),
        controller: 'AsideCtrl'
      },
      'header': {
        template: require('../../../layout/header.html'),
        controller: 'HeaderCtrl'
      },
      'chatbox': {
        template: require('../chatbox/chatbox.html'),
        controller: 'ChatboxController',
        controllerAs: 'chatbox'
      },
      'comments': {
        template: require('../chatbox/comments/comments.html'),
        controller: 'CommentsController',
        controllerAs: 'chatbox'
      },
      'footer': {
        template: require('../../../layout/footer.html')
      }
    },
    data: {
      displayName: 'Volver a Parametrización del Plan de Trabajo'
    }
  })
  .state('fullscreen.workPlanParametrization', {
    abstract: false,
    url: '/workPlanParametrizationList',
    template: require('./list/workPlanParametrizationList.html'),
    controller: 'WorkPlanParametrizationListCtrl',
    controllerAs: 'parametrizationListVM',
    data: {
      displayName: 'Parametrización plan de trabajo'
    }
  })
  .state('workPlanParametrization.workPlanCreate', {
    abstract: false,
    url: '/workPlanCreate',
    template: require('./create/workPlanCreate.html'),
    controller: 'WorkPlanCreateCtrl',
    controllerAs: 'createVM',
    data: {
      displayName: 'Configuración inicial',
      order: 1,
      siblings: [
        {
          name: 'workPlanParametrization.setupTeacherActivities',
          hideLink: true,
          order: 2
        }, {
          name: 'workPlanParametrization.workPlanHoursOfDedicated',
          hideLink: true,
          order: 3
        }
      ]
    }
  })
  .state('workPlanParametrization.workPlanAssignmentOfEvaluators', {
    abstract: false,
    url: '/workPlanAssignmentOfEvaluators',
    template: require('./reviewers/workPlanAssignmentOfEvaluators.html'),
    controller: 'WorkPlanAssignmentOfEvaluatorsCtrl',
    controllerAs: 'reviewersVM',
    data: {
      displayName: 'Asignación de evaluadores',
      order: 1
    }
  })
  .state('workPlanParametrization.activateWorkPlan', {
    abstract: false,
    url: '/activateWorkPlan',
    template: require('./activateWorkPlan/activateWorkPlan.html'),
    controller: 'ActivateWorkPlanCtrl',
    controllerAs: 'activateWorkPlanVM',
    data: {
      displayName: 'Activar plan de trabajo',
      order: 1
    }
  })
  .state('workPlanParametrization.workPlanHoursOfDedicated', {
    abstract: false,
    url: '/workPlanHoursOfDedicated/:id',
    template: require('./create/workPlanHoursOfDedicated.html'),
    controller: 'WorkPlanHoursOfDedicatedViewCtrl',
    controllerAs: 'hoursOfDedicationVM',
    data: {
      displayName: 'Horas de dedicación',
      order: 3,
      siblings: [
        {
          name: 'workPlanParametrization.workPlanViewSetup',
          order: 1,
          params: {id: 'id'}
        }, {
          name: 'workPlanParametrization.setupTeacherActivities',
          order: 2,
          params: {workPlanId: 'id'}
        }
      ]
    }
  })
  .state('workPlanParametrization.workPlanClone', {
    abstract: false,
    url: '/cloneWorkplan/:workPlanId',
    template: require('./create/workPlanCreate.html'),
    controller: 'WorkPlanCreateCtrl',
    controllerAs: 'createVM',
    data: {
      displayName: 'Clonar plan de trabajo',
      order: 1,
      siblings: [
        {
          name: 'workPlanParametrization.setupTeacherActivities',
          hideLink: true,
          order: 2
        }, {
          name: 'workPlanParametrization.workPlanHoursOfDedicated',
          hideLink: true,
          order: 3
        }
      ]
    }
  })
  .state('workPlanParametrization.workPlanView', {
    abstract: false,
    url: '/workPlan/:id/view',
    template: require('./view/workPlanView.html'),
    controller: 'WorkPlanViewCtrl',
    controllerAs: 'wpViewVM',
    data: {
      displayName: 'Configuración inicial',
      order: 1,
      siblings: [
        {
          name: 'workPlanParametrization.viewTeacherActivities',
          hideLink: false,
          order: 2,
          params: {workPlanId: 'id'}
        }, {
          name: 'workPlanParametrization.viewHoursOfDedicated',
          hideLink: false,
          order: 3,
          params: {id: 'id'}
        }
      ]
    }
  })
  .state('workPlanParametrization.workPlanViewSetup', {
    abstract: false,
    url: '/workPlan/:id/viewSetup',
    template: require('./view/workPlanView.html'),
    controller: 'WorkPlanViewCtrl',
    controllerAs: 'wpViewVM',
    data: {
      displayName: 'Configuración inicial',
      order: 1,
      siblings: [
        {
          name: 'workPlanParametrization.setupTeacherActivities',
          hideLink: false,
          order: 2,
          params: {workPlanId: 'id'}
        }, {
          name: 'workPlanParametrization.workPlanHoursOfDedicated',
          hideLink: false,
          order: 3,
          params: {id: 'id'}
        }
      ]
    }
  })
  .state('workPlanParametrization.setupTeacherActivities', {
    abstract: false,
    url: '/setupTeacherActivities/:workPlanId',
    template: require('./activities/setupTeacherActivities.html'),
    controller: 'SetupTeacherActivitiesCtrl',
    controllerAs: 'setupVM',
    data: {
      displayName: 'Config. actividades',
      order: 2,
      siblings: [
        {
          name: 'workPlanParametrization.workPlanViewSetup',
          order: 1,
          params: {id: 'workPlanId'}
        }, {
          name: 'workPlanParametrization.workPlanHoursOfDedicated',
          order: 3,
          params: {id: 'workPlanId'}
        }
      ]
    }
  })
  .state('workPlanParametrization.viewTeacherActivities', {
    abstract: false,
    url: '/viewTeacherActivities/:workPlanId',
    template: require('./activities/viewTeacherActivities.html'),
    controller: 'SetupTeacherActivitiesCtrl',
    controllerAs: 'setupVM',
    data: {
      displayName: 'Config. actividades',
      order: 2,
      siblings: [
        {
          name: 'workPlanParametrization.workPlanView',
          order: 1,
          params: {id: 'workPlanId'}
        },
        {
          name: 'workPlanParametrization.viewHoursOfDedicated',
          order: 3,
          params: {id: 'workPlanId'}
        }
      ]
    }
  })
  .state('workPlanParametrization.viewHoursOfDedicated', {
    abstract: false,
    url: '/viewHoursOfDedicated/:id',
    template: require('./create/viewHoursOfDedicated.html'),
    controller: 'WorkPlanHoursOfDedicatedViewCtrl',
    controllerAs: 'hoursOfDedicationVM',
    data: {
      displayName: 'Horas de dedicación',
      order: 3,
      siblings: [
        {
          name: 'workPlanParametrization.workPlanView',
          order: 1,
          params: {id: 'id'}
        }, {
          name: 'workPlanParametrization.viewTeacherActivities',
          order: 2,
          params: {workPlanId: 'id'}
        }
      ]
    }
  })
  .state('workPlanParametrization.criteriaListView', {
    abstract: false,
    url: '/criteriaLists',
    template: require('./criteria/criteriaListView.html'),
    controller: 'CriteriaListViewCtrl',
    controllerAs: 'criteriaListVM',
    data: {
      displayName: 'Criterios de revisión/aprobación',
      order: 1,
      siblings: [
        {
          name: 'workPlanParametrization.evaluationCriteriaList',
          order: 2
        }
      ]
    },
    params: {
      categoryId: {value: '1'}
    }
  })
  .state('workPlanParametrization.evaluationCriteriaList', {
    abstract: false,
    url: '/evaluationCriteriaLists',
    template: require('./criteria/criteriaListView.html'),
    controller: 'CriteriaListViewCtrl',
    controllerAs: 'criteriaListVM',
    data: {
      displayName: 'Criterios de evaluación',
      order: 2,
      siblings: [
        {
          name: 'workPlanParametrization.criteriaListView',
          order: 1
        }
      ]
    },
    params: {
      categoryId: {value: '2'}
    }
  })
  .state('workPlanParametrization.specialSituationsView', {
    abstract: false,
    url: '/specialSituations',
    template: require('./special/specialSituationsView.html'),
    controller: 'SpecialSituationsCtrl',
    controllerAs: 'specialSituationVM',
    data: {
      displayName: 'Situaciones Especiales',
      order: 1
    }
  })
  .state('workPlanParametrization.modules', {
    abstract: false,
    url: '/modules',
    template: require('./modules/setupTeacherTypeModules.html'),
    controller: 'SetupTeacherTypeModulesCtrl',
    controllerAs: 'setupTeacherTypeModulesVM',
    data: {
      displayName: 'Módulos',
      order: 1
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/workPlanParametrization.route.js